import { Platform } from 'react-native';
import { fetchProducts, isEligibleForIntroOfferIOS, type ProductSubscription } from 'expo-iap';
import api from './api';
import { getAppleProductId, initIAPConnection } from './appleIapService';
import { GOOGLE_INTRO_OFFER_ID, getGoogleProductId } from './googlePlayIapService';

/**
 * Oferta de boas-vindas: o 1º mês do plano por um valor simbólico.
 * Configurada nas três pontas (oferta introdutória na App Store, oferta
 * `primeiro-mes` no Google Play, cupom na Stripe); cada uma decide quem ainda
 * tem direito, e é uma oferta por pessoa, valendo para um plano só.
 * O Pro é o que o onboarding destaca.
 */
export const INTRO_OFFER = { planId: 'professional', price: 1.99 } as const;

/** Preço do 1º mês de cada plano com oferta. */
export const INTRO_OFFER_PRICES: Record<string, number> = {
  basic: 0.99,
  professional: INTRO_OFFER.price,
  enterprise: 4.99,
};

/** Se esta conta (e, no app, este Apple ID / conta Google) ainda pega a oferta. */
export async function fetchIntroOfferEligible(): Promise<boolean> {
  if (Platform.OS === 'web') {
    const res = await api.get<{ eligible: boolean }>('/stripe/intro-offer');
    return res.data.eligible;
  }

  const sku =
    Platform.OS === 'ios'
      ? getAppleProductId(INTRO_OFFER.planId)
      : getGoogleProductId(INTRO_OFFER.planId);
  if (!sku) return false;

  await initIAPConnection();
  const [product] = ((await fetchProducts({ skus: [sku], type: 'subs' })) ??
    []) as ProductSubscription[];
  if (!product) return false;

  if (product.platform === 'android') {
    // O Google só lista as ofertas que a conta pode usar.
    return (product.subscriptionOfferDetailsAndroid ?? []).some(
      (offer) => offer.offerId === GOOGLE_INTRO_OFFER_ID,
    );
  }

  const groupID =
    product.subscriptionGroupIdIOS ?? product.subscriptionInfoIOS?.subscriptionGroupId;
  if (!groupID || !product.introductoryPriceIOS) return false;
  return isEligibleForIntroOfferIOS(groupID);
}
